import React, { PureComponent } from 'react'
import Hotkeys from 'react-hot-keys'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { updateIdentity } from '../actions/identity_info_modal_dialog'
import { resetModalConfirmation } from '../actions/modal_confirmation'
import { updateDocumentData } from '../actions/update_document_data'
import { DivContentBox, DivTitleBox } from '../components/common/styled'
import { MultiStepForm } from '../components/multistep-form/multi-step-form'
import Spinner3Bounce from '../components/spinner_3_bounce'
import { checkSession, fetchUserTxById, resetFetchUserTxById } from '../actions'
import DocumentInformationStep from '../components/wizard/document_information_step'
import IdentityInformationStep from '../components/wizard/identity_information_step'
import InvestorInformationStep from '../components/wizard/investor_information_step'
import WizardGallery from '../components/wizard/wizard_gallery'
import { fetchGenericTypeDocuments } from '../actions/supported_documents'
import { rotate } from '../utils/images'

const ROTATE_KEY = 'control+r'

const onKeyUp = (keyName, e, handle) => {
  if (keyName === ROTATE_KEY) {
    rotate()
  }
}
const onKeyDown = (keyName, e, handle) => {}

const convertIdentityDocuments = (identityDocuments, identityDataSources) => {
  const entities = {}
  identityDocuments.forEach((e) => {
    entities[e.id] = {
      can_bypass_expiration: e.can_bypass_expiration,
      expiration_date: e.expiration_date,
      document_type: e.document_type,
      document_classification: e.document_classification,
      identity_data_source: identityDataSources,
    }
  })
  return entities
}

export class WizardForm extends PureComponent {
  state = {
    identityInformationStep: {
      transactionIdentity: {},
    },
    isIdentityStepValid: true,
    isDocumentStepValid: true,
    documentInformationStep: {
      transactionIdentity: {},
      identityDocuments: {},
    },
    investorInformationStep: {
      transactionIdentity: {},
    },
    transactionIdentityId: null,
    isSaving: false,
  }

  async componentDidMount() {
    const { id, fetchUserTxById, fetchGenericTypeDocuments } = this.props
    fetchUserTxById(id)
    fetchGenericTypeDocuments()
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.userTx && nextProps.userTx.transaction_identity) {
      const images = nextProps.userTx.transaction_identity.identity_documents
        .reduce((array, item) => {
          if (item.document_type === 'front' || item.document_type === 'passport') {
            array.unshift(item)
          } else {
            array.push(item)
          }
          return array
        }, [])
        .map((d) => ({
          original: d.document,
          thumbnail: d.document,
        }))
      this.setState({ images })
      const data = nextProps.userTx.transaction_identity
      const identityInformationStep = {
        transactionIdentity: {
          first_name: data.first_name || '',
          middle_name: data.middle_name || '',
          last_name: data.last_name || '',
          alias: data.alias || '',
          gender: data.gender || '',
          birth_date: data.birth_date || null,
          selected_country_code: data.selected_country_code || '',
        },
      }
      const identityDocuments = convertIdentityDocuments(
        data.identity_documents.filter(
          (i) =>
            i.is_active && i.state !== 'disabled' && (i.document_type === 'front' || i.document_type === 'passport')
        ) || {},
        data.identity_data_sources
      )

      const documentInformationStep = {
        transactionIdentity: {
          country_code: data.country_code || '',
          drivers_license: data.drivers_license || '',
          passport_number: data.passport_number || '',
        },
        identityDocuments,
      }

      const investorInformationStep = {
        transactionIdentity: {
          signer_type: data.signer_type || '',
          investor_type: data.investor_type || '',
          notes: data.notes || '',
        },
      }

      const transactionIdentityId = data.id
      this.setState({
        identityInformationStep,
        documentInformationStep,
        investorInformationStep,
        transactionIdentityId,
      })
    }
  }

  onBeforeNext = (name) => {
    if (name === 'identityInformationStep') {
      const { transactionIdentity } = this.state.identityInformationStep
      if (!transactionIdentity.first_name) {
        if (!window.confirm('First Name is a required field in many jurisdictions. Would you like to enter it?')) {
          return true
        } else {
          return false
        }
      }
      if (!transactionIdentity.last_name) {
        if (
          !window.confirm(
            'Last Name is a required field in many jurisdictions. Would you like to enter it? \n' +
              'Click OK to enter a last name. Click Cancel to bypass and save record with no last name.'
          )
        ) {
          return true
        } else {
          return false
        }
      }
    }
    return true
  }
  onNext = async (name) => {
    await this.save(name)
  }

  save = async (name) => {
    const { state, props } = this
    const { transactionIdentityId } = state
    const { transactionIdentity, identityDocuments } = state[name]
    if (name === 'investorInformationStep' && transactionIdentity.investor_type === '') {
      return
    }
    this.setState({ isSaving: true })
    try {
      await this.props.updateIdentity(transactionIdentityId, transactionIdentity)
      if (identityDocuments) {
        const ids = Object.keys(identityDocuments)
        if (ids.length) {
          await Promise.all(
            ids.map((id) =>
              props.updateDocumentData(transactionIdentityId, id, {
                can_bypass_expiration: identityDocuments[id].can_bypass_expiration,
                expiration_date: identityDocuments[id].expiration_date,
                document_classification: identityDocuments[id].document_classification,
              })
            )
          )
        }
      }
    } finally {
      this.setState({ isSaving: false })
    }
  }

  onPrevious = (name, value) => {
    console.log('prev')
  }

  onGoBack = (name, value) => {
    if (this.props.history.length) {
      try {
        this.props.history.goBack()
      } catch (e) {
        this.props.history.push(`/tx-details/${this.props.id}`)
      }
    } else {
      this.props.history.push(`/tx-details/${this.props.id}`)
    }
  }

  onFinish = async (name) => {
    await this.save(name)
    if (this.props.history.length) {
      try {
        this.props.history.goBack()
      } catch (e) {
        this.props.history.push(`/tx-details/${this.props.id}`)
      }
    } else {
      this.props.history.push(`/tx-details/${this.props.id}`)
    }
  }

  handleInvestorInformationChange = (name, value, entity) =>
    this.setState((prevState) => ({
      [name]: { ...prevState[name], ...{ [value]: { ...prevState[name][value], ...entity } } },
    }))

  handleTransactionIdentityChange = (name, value, entity, isValid) => {
    this.setState({ isIdentityStepValid: isValid })
    if (entity) {
      if (entity.gender) {
        entity.gender = entity.gender.toLowerCase()
      }
      return this.setState((prevState) => ({
        [name]: { ...prevState[name], ...{ [value]: { ...prevState[name][value], ...entity } } },
      }))
    }
  }

  handleDocumentStepChange = (name, value, entity, isValid) => {
    if (isValid !== undefined) {
      this.setState({ isDocumentStepValid: isValid })
    }
    this.setState((prevState) => ({
      [name]: { ...prevState[name], ...{ [value]: { ...prevState[name][value], ...entity } } },
    }))
  }

  setValidationState = (isValid) => {
    this.setState({ isDocumentStepValid: isValid })
  }

  isValid = () => {
    return this.state.isIdentityStepValid
  }

  render() {
    const { props, state } = this
    const { isAuthenticated, isFetching, userTx, genericTypes } = props

    if (!isAuthenticated) {
      return null
    }
    if (isFetching || !userTx) {
      return (
        <div className='text-center grid-spinner-mt-240'>
          <Spinner3Bounce isActive />
        </div>
      )
    }
    return (
      <Hotkeys
        keyName={[ROTATE_KEY].join(',')}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        filter={(event) => {
          return true
        }}
      >
        <div className='ibox float-e-margins animated fadeIn section-shadow'>
          <DivTitleBox className='ibox-title'>
            <div className='row'>
              <div className='col-xs-6 col-sm-6'>
                <h2>Edit Identity</h2>
              </div>
            </div>
          </DivTitleBox>
          <DivContentBox className='ibox-content'>
            <WizardGallery images={state.images} />
            <MultiStepForm
              showNavigation
              onNext={this.onNext}
              onBeforeNext={this.onBeforeNext}
              onPrevious={this.onPrevious}
              onGoBack={this.onGoBack}
              onFinish={this.onFinish}
              isValid={this.isValid()}
              isDocumentStepValid={this.state.isDocumentStepValid}
              isBusy={this.state.isSaving}
              steps={[
                {
                  name: 'identityInformationStep',
                  component: (
                    <IdentityInformationStep
                      data={state.identityInformationStep.transactionIdentity}
                      handleChange={this.handleTransactionIdentityChange}
                    />
                  ),
                },
                {
                  name: 'documentInformationStep',
                  component: (
                    <DocumentInformationStep
                      genericTypes={genericTypes}
                      data={state.documentInformationStep.transactionIdentity}
                      identityDocuments={state.documentInformationStep.identityDocuments}
                      handleChange={this.handleDocumentStepChange}
                      setValidationState={this.setValidationState}
                    />
                  ),
                },
                {
                  name: 'investorInformationStep',
                  component: (
                    <InvestorInformationStep
                      data={state.investorInformationStep.transactionIdentity}
                      handleChange={this.handleInvestorInformationChange}
                    />
                  ),
                },
              ]}
            />
          </DivContentBox>
        </div>
      </Hotkeys>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: state.auth.isAuthenticated,
  userTx: state.txById.userTx,
  id: ownProps.match.params.id,
  genericTypes: state.fetchGenericTypeDocuments.results,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      checkSession,
      fetchUserTxById,
      updateDocumentData,
      resetModalConfirmation,
      resetFetchUserTxById,
      fetchGenericTypeDocuments,
      updateIdentity,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WizardForm))
